﻿import { dbfetch } from "./dbfetch";
import { createElement } from "./_dom";
import { createBigSpinner } from "./spinner";

// const delayAsync = async timeout => new Promise(resolve => setTimeout(resolve, timeout));

async function renderChart(id, url) {
	var chartView = document.getElementById(id);
	chartView.setAttribute("aria-busy", "true");
	var spinner = createBigSpinner();
	spinner.classList.add("hide");
	chartView.replaceChildren(spinner);
	const spinnerTimeoutId = setTimeout(() => spinner?.classList.remove("hide"), 300);

	url += "&svg=1";
	const w = Math.max((chartView.clientWidth | 0) - 8, 480);
	url += "&w=-" + w;
	try {
		const timeout = 3 * 60 * 1000;
		const abortController = new AbortController();
		const abortTimeoutId = setTimeout(() => abortController.abort("Request timeout"), timeout);
		// await delayAsync(timeout);
		const response = await dbfetch(url, { signal: abortController.signal });
		clearTimeout(spinnerTimeoutId);
		clearTimeout(abortTimeoutId);
		if (!response.ok) {
			let message = response.statusText; // won't work in HTTP/2, but better than nothing
			const ct = response.headers.get("Content-Type");
			if (/^text\/plain(;|$)/.test(ct)) {
				message = await response.text();
			}
			throw new Error(message);
		}
		const text = await response.text();
		const svgDoc = new DOMParser().parseFromString(text, "image/svg+xml");
		const svg = document.importNode(svgDoc.documentElement, true);
		chartView.setAttribute("aria-busy", "false");
		chartView.replaceChildren(svg);
	} catch (e) {
		clearTimeout(spinnerTimeoutId);
		var p = createElement("p", { class: "v3-layout__error v3-error" }, e.message || e.toString());
		chartView.setAttribute("aria-busy", "false");
		chartView.replaceChildren(p);
	}
}

function chartViewVisible(entries, observer) {
	entries.forEach(({ isIntersecting, target: chart }) => {
		if (isIntersecting) {
			observer.unobserve(chart);
			renderChart(chart.id, chart.dataset.jsChartView);
		}
	});
}

async function init(context) {
	var observer = new IntersectionObserver(chartViewVisible);
	context.querySelectorAll("[data-js-chart-view]").forEach(c => observer.observe(c));
}

export { init };